import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import service1 from '../assets/img/vector/internet.svg';
import service2 from '../assets/img/vector/servidores-dedicados.svg';
import service3 from '../assets/img/vector/desarrollo-img.svg';
import service4 from '../assets/img/vector/soporte.svg';
import Testimonials from '../subcomponents/Testimonials';
import Section from '../layout/Section';
import SectionContainer from '../subcomponents/SectionContainer';
import IconBlock28 from '../subcomponents/IconBlock28';
import home1 from '../assets/img/flat/home1.svg';
import home2 from '../assets/img/flat/home2.svg';
import home3 from '../assets/img/flat/home3.svg';
import MiniCarousel from '../subcomponents/MiniCarousel';
import listadoClientes from '../assets/data/clientes';

import housingImg from '../assets/img/flat/housing3.svg';
import servidoresDedicadosImg from '../assets/img/flat/servidordedicado2.svg';
import cloudVPSImg from '../assets/img/flat/cloudvps1.svg';
import Slider from '../subcomponents/Slider';

class Home extends Component {

  componentDidMount() {
    document.title = 'Insacom';
    /* eslint-disable */
    $('.masonry-grid')
      .imagesLoaded()
      .then(function () {
        $('.masonry-grid').masonry({
          columnWidth: '.masonry-grid-sizer',
          itemSelector: '.masonry-grid-item',
          percentPosition: true
        });
      });
    if ($('[data-bg-img-src]').length) $.HSCore.helpers.bgImage($('[data-bg-img-src]'));
  }

  render() {
    const clientes = listadoClientes.map(cliente => {
      return {
        title: cliente.nombre,
        img: require('../assets/img/clientes/' + cliente.imagen)
      };
    });
    let iconBlocks = [
      {
        id: 1,
        title: 'Servicio Rápido y Confiable',
        description:
          'Las mejores soluciones Informáticas y de Telecomunicaciones con personal certificado',
        img: home1
      },
      {
        id: 2,
        title: 'Todo en un Lugar',
        description:
          'Contamos con un equipo especializado en cada área para poder brindar un servicio de excelente calidad',
        img: home2
      },
      {
        id: 3,
        title: 'Cloud Computing',
        description:
          'Nuestros servicios en la Cloud cuentan con una Alta Disponibilidad y un rendimiento Insuperable',
        img: home3
      }
    ];
    return (
      <Section no-contact>
        <Slider />
        <SectionContainer>
          <IconBlock28 version={1} content={iconBlocks}></IconBlock28>
          <section>
            <div className="container g-pt-100 g-pb-70">
              <div className="text-center g-mb-50">
                <h2 className="h1 g-color-black g-font-weight-600">Nuestros Servicios</h2>
                <p className="lead">Revisa nuestra diversa gama de servicios</p>
              </div>
              <div className="masonry-grid row">
                <div className="masonry-grid-sizer col-lg-1"></div>
                <div className="masonry-grid-item g-mb-30 col-lg-7">
                  <article className="row align-items-stretch no-gutters u-shadow-v21 u-shadow-v21--hover g-transition-0_3">
                    <span
                      className="col-md-6 g-bg-pos-center g-min-height-300 g-rounded-right-5"
                      style={{
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat'
                      }}
                      data-bg-img-src={service4}
                    />
                    <div className="col-md-6 g-bg-white g-rounded-left-5">
                      <div className="g-bg-white g-pa-20 g-rounded-bottom-5">
                        <h2 className="h5 g-color-black g-font-weight-600 mb-4">
                          <span className="g-color-black g-color-primary--hover">Servicios TI</span>
                        </h2>
                        <ul className="list-inline g-font-size-12 mb-0">
                          <li className="list-inline-item g-mb-10">
                            <Link
                              className="u-tags-v1 g-font-size-14 g-color-purple g-bg-purple-opacity-0_1 g-bg-purple--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                              to="/servicios/redes-gestionadas">
                              Redes Gestionadas
                            </Link>
                          </li>
                          <li className="list-inline-item g-mb-10">
                            <Link
                              className="u-tags-v1 g-font-size-14 g-color-cyan g-bg-cyan-opacity-0_1 g-bg-cyan--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                              to="/servicios/monitoreo-red">
                              Monitoreo De Red
                            </Link>
                          </li>
                          <li className="g-mb-10 list-inline-item">
                            <Link
                              className="u-tags-v1 g-font-size-14 g-color-orange g-bg-orange-opacity-0_1 g-bg-orange--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                              to="/servicios/firewall">
                              Firewall
                            </Link>
                          </li>
                          <li className="list-inline-item g-mb-10">
                            <Link
                              className="u-tags-v1 g-font-size-14 g-color-green g-bg-green-opacity-0_1 g-bg-green--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                              to="/servicios/soporte-integral">
                              Soporte Integral
                            </Link>
                          </li>
                          <li className="list-inline-item g-mb-10">
                            <Link
                              className="u-tags-v1 g-font-size-14 g-color-blue g-bg-blue-opacity-0_1 g-bg-blue--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                              to="/servicios/plataforma-wifi">
                              Plataforma WiFi
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </article>
                </div>
                <div className="masonry-grid-item g-mb-30 col-lg-5">
                  <article className="u-shadow-v21 u-shadow-v21--hover g-transition-0_3">
                    <span>
                      <img
                        className="img-fluid w-100 g-rounded-top-5"
                        src={service3}
                        alt="Software"
                      />
                    </span>
                    <div className="g-bg-white g-pa-20 g-rounded-bottom-5">
                      <h2 className="h5 g-color-black g-font-weight-600 mb-4">
                        <span className="u-link-v5 g-color-black g-color-primary--hover">
                          Software
                        </span>
                      </h2>
                      <ul className="list-inline g-font-size-12 mb-0">
                        <li className="list-inline-item g-mb-10">
                          <Link
                            className="u-tags-v1 g-font-size-14 g-color-teal g-bg-teal-opacity-0_1 g-bg-teal--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                            to="/servicios/cloud-backup">
                            Cloud Backup
                          </Link>
                        </li>
                        <li className="list-inline-item g-mb-10">
                          <Link
                            className="u-tags-v1 g-font-size-14 g-color-green g-bg-green-opacity-0_1 g-bg-green--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                            to="/servicios/desarrollo-software">
                            Desarrollo de Software
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </article>
                </div>
                <div className="masonry-grid-item g-mb-30 col-lg-7">
                  <article className="u-shadow-v21 u-shadow-v21--hover g-transition-0_3 g-bg-primary text-center g-rounded-5 g-pa-30 g-py-100">
                    <h2 className="h3 g-color-white g-font-weight-600 mb-4">
                      La integración de nuestros servicios optimiza los recursos de tu empresa
                    </h2>
                  </article>
                </div>

                <div className="masonry-grid-item g-mb-30 col-lg-5">
                  <article className="u-shadow-v21 u-shadow-v21--hover g-transition-0_3">
                    <img
                      className="img-fluid w-100 g-rounded-top-5"
                      src={service2}
                      alt="Data Center"
                    />
                    <div className="g-bg-white g-pa-20 g-rounded-bottom-5">
                      <h2 className="h5 g-color-black g-font-weight-600 mb-4">
                        <span className="u-link-v5 g-color-black g-color-primary--hover">
                          Data Center
                        </span>
                      </h2>
                      <ul className="list-inline g-font-size-12 mb-0">
                        <li className="list-inline-item g-mb-10">
                          <Link
                            className="u-tags-v1 g-font-size-14 g-color-lightred g-bg-lightred-opacity-0_1 g-bg-lightred--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                            to="/servicios/hosting-enterprise">
                            Hosting Enterprise
                          </Link>
                        </li>
                        <li className="list-inline-item g-mb-10">
                          <Link
                            className="u-tags-v1 g-font-size-14 g-color-teal g-bg-teal-opacity-0_1 g-bg-teal--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                            to="/servicios/cloud-vps">
                            Cloud VPS
                          </Link>
                        </li>
                        <li className="list-inline-item g-mb-10">
                          <Link
                            className="u-tags-v1 g-font-size-14 g-color-green g-bg-green-opacity-0_1 g-bg-green--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                            to="/servicios/servidores-dedicados">
                            Servidores Dedicados
                          </Link>
                        </li>
                        <li className="list-inline-item g-mb-10">
                          <Link
                            className="u-tags-v1 g-font-size-14 g-color-blue g-bg-blue-opacity-0_1 g-bg-blue--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                            to="/servicios/housing">
                            Housing
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </article>
                </div>
                <div className="masonry-grid-item g-mb-30 col-lg-7">
                  <article className="row align-items-stretch no-gutters u-shadow-v21 u-shadow-v21--hover g-transition-0_3">
                    <div className="col-md-6 g-bg-white g-rounded-left-5">
                      <div className="g-bg-white g-pa-20 g-rounded-bottom-5">
                        <h2 className="h5 g-color-black g-font-weight-600 mb-4">
                          <span className="g-color-black g-color-primary--hover">
                            Telecomunicaciones
                          </span>
                        </h2>
                        <ul className="list-inline g-font-size-12 mb-0">
                          <li className="list-inline-item g-mb-10">
                            <Link
                              className="u-tags-v1 g-font-size-14 g-color-lightred g-bg-lightred-opacity-0_1 g-bg-lightred--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                              to="/servicios/internet">
                              Internet
                            </Link>
                          </li>
                          <li className="list-inline-item g-mb-10">
                            <Link
                              className="u-tags-v1 g-font-size-14 g-color-teal g-bg-teal-opacity-0_1 g-bg-teal--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                              to="/servicios/telefonia-ip">
                              Telefonía IP
                            </Link>
                          </li>
                          <li className="list-inline-item g-mb-10">
                            <Link
                              className="u-tags-v1 g-font-size-14 g-color-yellow g-bg-yellow-opacity-0_1 g-bg-yellow--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                              to="/servicios/enlace-datos">
                              Enlace de Datos
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <span
                      className="col-md-6 g-bg-pos-center g-min-height-250 g-rounded-right-5"
                      style={{
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat'
                      }}
                      data-bg-img-src={service1}
                    />
                  </article>
                </div>
              </div>
            </div>
          </section>
        </SectionContainer>
        <Testimonials />
        <SectionContainer backgroundColor={'#000000eb'}>
          <div className="row">
            <div className="col-lg-4 g-mb-60 g-mt-60" style={{ minHeight: 350 }}>
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={housingImg} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Hosting Enterprise
                </h3>
                <p className="g-mb-20">
                  Contamos con una amplia variedad de planes de hosting para tu proyecto, alojado en
                  datacenter propio.
                </p>
                <div className="bottom-pill-btn">
                  <Link
                    className="btn-block btn-xl g-font-weight-600 g-font-size-12 g-text-underline--none--hover text-uppercase btn u-btn-primary"
                    to="/servicios/hosting-enterprise">
                    Ver Planes
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 g-mb-60 g-mt-60" style={{ minHeight: 350 }}>
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={cloudVPSImg} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Cloud VPS
                </h3>
                <p className="g-mb-20">
                  Tu mejor elección para proyectos en crecimiento. La libertad de un servidor
                  independiente, con el mejor rendimiento y disponibilidad.
                </p>
                <div className="bottom-pill-btn">
                  <Link
                    className="btn-block btn-xl g-font-weight-600 g-font-size-12 g-text-underline--none--hover text-uppercase btn u-btn-primary"
                    to="/servicios/cloud-vps">
                    Ver Planes
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 g-mb-60 g-mt-60" style={{ minHeight: 350 }}>
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={servidoresDedicadosImg} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Servidores Dedicados
                </h3>
                <p className="g-mb-20">
                  Si tus exigencias son las más altas y necesitas contar con hardware a la medida,
                  contamos con una amplia variedad de equipos para soportar distintas cargas de
                  trabajo.
                </p>
                <div className="bottom-pill-btn">
                  <Link
                    className="btn-block btn-xl g-font-weight-600 g-font-size-12 g-text-underline--none--hover text-uppercase btn u-btn-primary"
                    to="/servicios/servidores-dedicados">
                    Ver Planes
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </SectionContainer>
        <div className="g-bg-img-hero g-bg-size-cover">
          <section className="clearfix g-px-15 g-py-100 g-pb-130 ">
            <div className="g-max-width-600 text-center mx-auto g-mb-60">
              <h2 className="g-color-gray-dark-v1 g-font-weight-600 g-font-size-30 mb-4">
                Nuestros <span className="g-color-primary g-font-size-35">Clientes</span>
              </h2>
              <p className="g-color-gray-dark-v3 g-font-size-18">
                Hace más de 10 años que Insacom presta servicios a empresas de diverso tamaño que se
                especializan en diferentes rubros, manteniendo una relación de confianza a largo
                plazo.
              </p>
            </div>
            <div className="container" style={{ maxWidth: 1500 }}>
              <MiniCarousel slidesScroll={4} slidesPerPage={4} content={clientes}></MiniCarousel>
            </div>
          </section>
        </div>
      </Section>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/sections/Home.js